import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import AreaChart from "recharts/es6/chart/AreaChart";
import Area from "recharts/es6/cartesian/Area";
import XAxis from "recharts/es6/cartesian/XAxis";
import YAxis from "recharts/es6/cartesian/YAxis";
import Tooltip from "recharts/es6/component/Tooltip";
import ResponsiveContainer from "recharts/es6/component/ResponsiveContainer";
import SelectionNotAvailable from './SelectionNotAvailable';


const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div style={{ backgroundColor: '#FFF', boxShadow: '0 1px 28px 5px rgba(0, 0, 0, 0.06)', paddingLeft: '20px', paddingTop: '15px', paddingRight: '20px', paddingBottom: '10px' }} >
        <div style={{ width: '13px', height: '13px', backgroundColor: '#2de6d5', display: "inline-block" }}></div>
        <p style={{ display: "inline", paddingLeft: '5px' }}>
        {
          payload[0].dataKey === 'count'
          ? `Hour ${label}:00 - ${payload[0].value}`
          : `${moment(label).format('dddd Do MMMM')} - ${payload[0].value}`
        }
        </p>
      </div>
    );
  }

  return null;
};

const FootfallOverTimeGraph = props => (
  <div className="FootfallOverTimeGraph">
    <div className="FootfallOverTimeGraph_top-row">
      <div className="FootfallOverTimeGraph_top-row_text">
        <h3 className="content-card_title">
          Footfall {props.unit === 'day' ? 'over time' : 'by the hour'}
        </h3>
      </div>
      <div className="FootfallOverTimeGraph_top-row_button-group">
        <button
          onClick={() => props.setUnit('day')}
          className={props.unit === 'day' ? 'selected' : ''}
        >
          Date range
        </button>
        <button
          onClick={() => props.setUnit('hour')}
          className={props.unit === 'hour' ? 'selected' : ''}
        >
          Hourly average
        </button>
      </div>
    </div>
    <div className="FootfallOverTimeGraph_inner">
    {props.data.length !== 0
        ? <ResponsiveContainer width="100%" height="100%" >
          <AreaChart
            data={props.data}
            margin={{ top: 75 }}
          >
            <XAxis
              dataKey={props.data[0].timestamp !== undefined ? "timestamp" : 'hour'}
              tick={{ fontSize: 11 }}
              tickFormatter={props.data[0].timestamp !== undefined ? (tick) => moment(tick).format('MMM D') : (tick) => tick}
            />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={(tick) => `${tick}`} domain={['auto', 'auto']} />/>
            <Tooltip content={<CustomTooltip />} wrapperStyle={{ padding: '10px' }} />
            <Area type="monotone" dataKey={props.data[0].timestamp !== undefined ? "value" : 'count'} stroke="#2de6d5" fill="#2de6d5" fillOpacity={0.3} />
          </AreaChart>
        </ResponsiveContainer>

        : <SelectionNotAvailable
          text='Graph Currently Unavailable'
          buttonText=''
          /> }
    </div>
  </div>
);

FootfallOverTimeGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  unit: PropTypes.string.isRequired,
  footfallName: PropTypes.string.isRequired,
  setUnit: PropTypes.func.isRequired,
};

export default FootfallOverTimeGraph;
